module.exports = __webpack_public_path__ + "magnet.jpg?a0b1993ad6168df528031074e4227c16";